import React, { useCallback, useState } from 'react';
import { Tab, TabItem } from 'KN-EU-Broker-Dashboard-UI';
import { Dimmer, Loader, Segment, Button } from 'semantic-ui-react';
import EntrySummaryTab from '../tabs/EntrySummaryTab/EntrySummaryTab';
import EntryLineDetailsTab from '../tabs/entrySummaryDetailsTab/EntrylineDetailsTab';
import HeaderTab from '../tabs/headerTab/HeaderTab';
import { useDispatch, useSelector } from 'react-redux';
import actions from '../../slices/actions';
import useUpdateForm from '../../hooks/useUpdateForm';
import { get_CSV_FOR_RECON_PAGE } from '../../../apiCalls/MainFormRequests';

const ReconForm = () => {
  const {reconLoader: {formGlobalLoader=""}} = useSelector((state)=>state.loader) //to be updated
  const { currentJob } = useSelector((state)=>state.currentJob) //to be updated
  const {updateForm} = useUpdateForm();
  const [loadingCSVCurrently, setLoadingCSVCurrently] = useState(false);
  const dispatch = useDispatch();
  const onChange =useCallback((e)=> {
    const parent=e.target.closest(".responsiveGridCss1")
    const {id:itemId="", reducer:reducerName} = parent.dataset;
    const { name, value } = e.target;
    dispatch(actions[reducerName]({name, value, itemId}));
  }, [])
  
  const onBlur = useCallback((e, event="RECON_SHIPMENT_UPDATE", otherFields={}) => {
    updateForm(e, event, otherFields);
  }, [])
  const onSelect = useCallback((e, data, event="RECON_SHIPMENT_UPDATE") => {
    const {name, value} = data;
    e.target.name = name;
    e.target.value = value;
    onChange(e);
    onBlur(e, event)
  }, [])
  const paymentOnSelect = useCallback((e, data, event="PAYMENT_UPDATE", otherFields) => {
    const {name, value, id} = data;
    e.target.name = name;
    e.target.value = value;
    onChange(e);
    e.target.name = id;
    onBlur(e, event, otherFields)
  }, [onChange, onBlur])

  
  let openCSV = (tabName)=>{
    if(loadingCSVCurrently)return;
    setLoadingCSVCurrently(true);
    
    get_CSV_FOR_RECON_PAGE(currentJob.reconShipmentId,tabName).then((resppp)=>{
      setLoadingCSVCurrently(false);
      window.open(
        resppp.data.eventMessage.url,
        "_blank",
        "noopener,noreferrer"
      );

    })
  }

  return (
    <>
      <Dimmer active={formGlobalLoader} inverted>
        <Loader size='medium'>Loading...</Loader>
      </Dimmer>
      <Tab className='euForm'>
        <TabItem title='Header' id='headerTab'>
          <Button  disabled={loadingCSVCurrently} type='button' 
            onClick={()=>{openCSV("HEADER");}}>
              {loadingCSVCurrently?'Loading...':'\u21E9 Header CSV'}
            </Button>
          <Button  disabled={loadingCSVCurrently} type='button' 
            onClick={()=>{openCSV("RECONCILIATION_HEADER");}}>
              {loadingCSVCurrently?'Loading...':'\u21E9 Recon Header CSV'}
            </Button>
          <HeaderTab onChange={onChange} onBlur={onBlur} onSelect={onSelect} paymentOnSelect={paymentOnSelect} />
        </TabItem>
        <TabItem title='Entry Summaries' id='entrySummaryTab'>
          <Button 
            disabled={loadingCSVCurrently}
            type='button'
            onClick={()=>{
              openCSV("ENTRY_SUMMARIES");
            }}
          >
          {loadingCSVCurrently?'Loading...':'\u21E9 Entry Summary CSV'}
          </Button>
          <Button  disabled={loadingCSVCurrently} type='button' 
            onClick={()=>{openCSV("RECONCILIATION_ASSOCIATION_REPORT");}}>
              {loadingCSVCurrently?'Loading...':'\u21E9 Recon Association Report CSV'}
            </Button>
          <EntrySummaryTab onChange={onChange} />
        </TabItem>
        <TabItem title='Entry Line Details' id='entryLineDetailTab'>
          <Button 
            disabled={loadingCSVCurrently}
            type='button'
            onClick={()=>{
              openCSV("ENTRY_LINE_DETAILS");
            }}
          >
            {loadingCSVCurrently?'Loading...':'\u21E9 Entry Details CSV'}
          </Button>
          <EntryLineDetailsTab />
        </TabItem>
        {/* <TabItem title='Billing' id='billingTab'>
          <>Billing Tab</>
        </TabItem> */}
      </Tab>
    </>
  );
};

export default ReconForm;

